<template>
    <ion-page>
        <standard-header title="All StockTakes" align="middle"/>
        <ion-content :fullscreen="true">
            <pull-down-refresh :callback="refresh"/>
            <skeleton :rows="4" v-if="stocktakes === null"/>
            <div v-show="stocktakes && stocktakes.length < 1">
                <no-results title="No Results">
                    No stocktakes found
                </no-results>
            </div>
            <div v-if="stocktakes !== null">
                <ion-list>
                    <div v-for="stocktake in stocktakes" :key="stocktake.id">
                        <ion-item lines="none">
                            <pick-list-item :stocktake="stocktake" :hide-due="true"  :completed="stocktake.has_concluded" />
                            <shipment-stock-take-user-assignment
                                :lineable-update-url="`/api/stocktakes/${stocktake.id}/users`"
                                user-permission="warehouse.stocktake"
                                :lineable="stocktake"
                                :users="users"
                                users-property="users"
                                :update-payload="{action:'none'}"
                            />
                        </ion-item>
                        <ion-progress-bar :value="stocktake.pc_complete/100"/>
                    </div>
                </ion-list>
            </div>
        </ion-content>
    </ion-page>
</template>

<script>
import {
    IonContent,
    IonItem,
    IonList,
    IonPage,
    IonProgressBar
} from '@ionic/vue';
import StandardHeader from "@/components/StandardHeader.vue";
import NoResults from "@/components/NoResults";
import EventBus from '@/EventBus';
import Skeleton from "@/components/Skeleton";
import PullDownRefresh from "@/components/PullDownRefresh";
import PrioritySorter from "@/services/PrioritySorter";
import PickListItem from "@/views/modules/picking/components/PickListItem";
import ShipmentStockTakeUserAssignment from "@/components/ShipmentStockTakeUserAssignment";

export default {
    inject: ['$http', '$toast', '$validationAlert'],
    name: 'AllPicksList',
    components: {
        ShipmentStockTakeUserAssignment,
        PickListItem,
        PullDownRefresh,
        Skeleton,
        NoResults,
        StandardHeader,
        IonContent, IonPage, IonItem, IonList, IonProgressBar
    },
    data() {
        return {
            stocktakes: null,
            users: []
        }
    },
    async mounted() {
        EventBus().emitter.emit('loading', true);
        await this.getUsers();
        await this.refresh();
        EventBus().emitter.emit('loading', false);
    },
    methods: {
        async getUsers() {
            return this.$http.get('/api/users', {
                params: {permissions: 'warehouse.stocktake', all: true}
            }).then(response => {
                this.users = response.data.items;
            }).catch(error => {
                this.$validationAlert(error);
            });
        },
        async refresh(event = null) {
            return this.$http.get('/api/stocktakes', {
                params: {
                    state: 'active',
                    include: 'users',
                    all: true
                }
            }).then(response => {
                this.stocktakes = PrioritySorter.sortByPriorityThen(response.data.items, 'reference');
            }).finally(() => {
                // pull down refresh gets us a new list of users
                if (event && event.target.complete) {
                    event.target.complete();
                }
            });
        }
    }
}
</script>
